import { useCallback, useRef } from 'react'
import { TranscriptionService } from '../transcription/TranscriptionService'
import { BrowserSpeechRecognition } from '../transcription/BrowserSpeechRecognition/BrowserSpeechRecognition'
import { WebsocketSpeechRecognition } from '../transcription/WebhookSpeechRecognition/WebhookSpeechRecognition'

export function useSpeechRecognition() {
  const transcriptionServiceRef = useRef<BrowserSpeechRecognition | WebsocketSpeechRecognition>()
  const start = useCallback(async (stream: MediaStream) => {
    const transcriptionService = await TranscriptionService.start(stream)
    transcriptionServiceRef.current = transcriptionService
  }, [])

  const pause = useCallback(() => {
    if (transcriptionServiceRef.current) {
      transcriptionServiceRef.current.pause()
    }
  }, [])

  const resume = useCallback(() => {
    if (transcriptionServiceRef.current) {
      transcriptionServiceRef.current.resume()
    }
  }, [])

  const stop = useCallback(() => {
    if (transcriptionServiceRef.current) {
      return transcriptionServiceRef.current.stop()
    }
  }, [])

  return { start, pause, resume, stop }
}
